"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const module_1 = require("../core/module");
class PromotionModule extends module_1.default {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v2/promotion/promotions/";
        this._canPaginate = true;
    }
    async list(params = {}, page = 1) {
        const results = (await this._list(page, params));
        return results;
    }
    retrieve(id, mode = "") {
        return this._retrieve(`${mode ? mode + "_" : ""}${id}`);
    }
}
exports.default = PromotionModule;
//# sourceMappingURL=promotions.js.map